function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, MouseEventHandler, ReactNode, RefObject, useRef } from 'react';
import cn from 'classnames';
import { usePreventScroll } from '../../hooks/usePreventScroll';
import { PortalExtendableProps, Portal } from '../Portal';
import { LayerManagerExtendableProps, LayerManager } from '../LayerManager';
require("./Modal.css");
var styles = {
  "Root": "Modal-module-Root_A_x",
  "Wrapper": "Modal-module-Wrapper_GE3",
  "Table": "Modal-module-Table_2bm",
  "Cell": "Modal-module-Cell_2YF",
  "topAlignCell": "Modal-module-topAlignCell_2VE",
  "middleAlignCell": "Modal-module-middleAlignCell_1E5",
  "bottomAlignCell": "Modal-module-bottomAlignCell_33k",
  "Content": "Modal-module-Content_Xrh",
  "Overlay": "Modal-module-Overlay_xL7",
  "visible": "Modal-module-visible_386",
  "defaultVariant": "Modal-module-defaultVariant_Tvo",
  "Modal_variant_default": "Modal-module-Modal_variant_default_LF9",
  "Modal-Content_variant_default": "Modal-module-Modal-Content_variant_default_1Xv",
  "Modal-Content_variant_default_visible": "Modal-module-Modal-Content_variant_default_visible_-iz",
  "hasAnimation": "Modal-module-hasAnimation_3ec"
};
const ModalVariants = {
  default: 'default'
};
/**
 * Используется для создания всплывающих модальных окон.
 */
export const Modal = ({
  children,
  className,
  classNameContainer,
  contentVerticalAlign: align = 'middle',
  variant = ModalVariants.default,
  hasAnimation = true,
  innerRef,
  controlRef,
  keepMounted,
  onClose,
  preventBodyScroll = true,
  scope,
  visible,
  zIndex,
  ...props
}) => {
  const contentRef = useRef(null);
  usePreventScroll({
    enabled: preventBodyScroll && visible
  });
  return /*#__PURE__*/React.createElement(Portal, {
    scope: scope,
    visible: visible,
    keepMounted: keepMounted
  }, /*#__PURE__*/React.createElement(LayerManager, {
    visible: visible,
    onClose: onClose,
    essentialRefs: [contentRef]
  }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: innerRef || controlRef,
    className: cn(styles.Root, styles[`${variant}Variant`], {
      [styles.visible]: visible,
      [styles.hasAnimation]: hasAnimation
    }, className),
    style: {
      zIndex
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.Overlay
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.Wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Table
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Cell, styles[`${align}AlignCell`])
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef,
    className: cn(styles.Content, classNameContainer)
  }, children)))))));
};
if (process.env.NODE_ENV !== 'production') {
  Modal.displayName = 'Modal';
}